<template>
  <div class="card search-card">
    <div class="card-body">
      <div class="status-bar">
        <router-link
          :to="{
            path: '/manager/recruitment/jobopening',
            query: { params: params },
          }"
        >
          <button
            type="button"
            class="go-back"
            @click="$store.commit('OpenDemandDetailModal', null)"
          >
            <i class="fas fa-arrow-circle-left"></i>
            {{ i18n("Buttons.GoBack") }}
          </button>
        </router-link>

        <!-- 檢視需求單 -->
        <button type="button" class="demand" @click="viewDemand">
          {{ i18n("StatusBar.ShowDemandDetail") }}
        </button>

        <!-- 履歷數量 -->
        <router-link
          :to="{
            path: 'resume',
            query: { did: this.demandNo, kind: this.resumeType, pos: this.positionName },
          }"
          class="status resume_list"
          :class="{ 'router-link-active': isLinkActive('resume') }"
        >
          <span>{{ i18n("StatusBar.ResumeList") }}</span>
          <div class="count">{{ this.$store.state.ResumeList }}</div>
        </router-link>

        <!-- 待面談 -->
        <router-link
          :to="{
            path: 'inviteinterview',
            query: { did: this.demandNo, kind: this.resumeType, pos: this.positionName },
          }"
          class="status interviewing"
          :class="{ 'router-link-active': isLinkActive('inviteinterview') }"
        >
          <span>{{ i18n("StatusBar.WaitInterview") }}</span>
          <div class="count">{{ this.$store.state.Interviewing }}</div>
        </router-link>

        <!-- 已面談 -->
        <router-link
          :to="{
            path: 'closeinterview',
            query: { did: this.demandNo, kind: this.resumeType, pos: this.positionName },
          }"
          class="status interviewed"
          :class="{ 'router-link-active': isLinkActive('closeinterview') }"
        >
          <span>{{ i18n("StatusBar.Interviewed") }}</span>
          <div class="count">{{ this.$store.state.Interviewed }}</div>
        </router-link>

        <!-- 面談未到 -->
        <router-link
          :to="{
            path: 'declineinterview',
            query: { did: this.demandNo, kind: this.resumeType, pos: this.positionName },
          }"
          class="status not_arrived"
          :class="{ 'router-link-active': isLinkActive('declineinterview') }"
        >
          <span>{{ i18n("StatusBar.DeclineInterview") }}</span>
          <div class="count">{{ this.$store.state.DeclineInterview }}</div>
        </router-link>

        <!-- 面談結果 -->
        <router-link
          :to="{
            path: 'interviewresult',
            query: { did: this.demandNo, kind: this.resumeType, pos: this.positionName },
          }"
          class="status interview_result"
          :class="{ 'router-link-active': isLinkActive('interviewresult') }"
        >
          <span>{{ i18n("StatusBar.InterviewResult") }}</span>
          <div class="count">{{ this.$store.state.InterviewResult }}</div>
        </router-link>

        <!-- 任用結果 -->
        <router-link
          :to="{
            path: 'evaluationresult',
            query: { did: this.demandNo, kind: this.resumeType, pos: this.positionName },
          }"
          class="status appoint_result"
          :class="{ 'router-link-active': isLinkActive('evaluationresult') }"
        >
          <span>{{ i18n("StatusBar.AppointResult") }}</span>
          <div class="count">{{ this.$store.state.AppointResult }}</div>
        </router-link>
      </div>
    </div>

    <!-- 檢視需求單 -->
    <DemandDetailModal />
  </div>
</template>

<script>
/* global $ */
import DemandDetailModal from "@/components/back/Modal/DemandDetail";

export default {
  props: ["params"],

  name: "StatusBar",

  components: {
    DemandDetailModal,
  },

  data() {
    return {
      demandNo: "",
      resumeType: "",
      positionName: "",
      ResumeViewCount: 0,
      InInterviewCount: 0,
      InterviewedCount: 0,
      InterviewNotArrivedCount: 0,
      InterviewResultCount: 0,
      AppointmentResultCount: 0,
    };
  },

  methods: {
    // 檢視需求單
    viewDemand() {
      this.$store.commit("OpenDemandDetailModal", this.demandNo);
    },

    // 判斷當前路徑是否包含目標字串
    isLinkActive(targetPath) {
      // 取得當前路由的路徑 (不含 query)
      const currentPath = this.$route.path;
      return currentPath.includes(targetPath);
    },

    // 多國語系
    i18n(keyStr) {
      return this.$t(keyStr);
    },
  },

  created() {
    this.demandNo = this.$route.query.did;
    this.resumeType = this.$route.query.kind;
    this.positionName = this.$route.query.pos;
    this.$store.dispatch("GetJobManagementCount");
  },

  destroyed() {
    $(".modal").modal("hide");
    $("body").removeClass("modal-open");
    $(".modal-backdrop").remove();
  },
};
</script>

<style lang="scss" scoped>
button:focus {
  outline: none;
}

//狀態列
.status-bar {
  margin-top: 20px;
  margin-bottom: 20px;
  @media screen and (max-width: 767px) {
    margin: 0;
  }

  .demand {
    position: relative;
    display: inline-block;
    vertical-align: middle;
    font-size: 0.9em;
    text-align: center;
    padding: 6px 10px;
    background-color: #17a2b8;
    color: #fff;
    margin-left: 5px;
    border-radius: 35px;
    border: none;
    box-shadow: -1px 3px 6px 1px rgba(0, 0, 0, 0.15);
  }

  .status {
    position: relative;
    display: inline-block;
    vertical-align: middle;
    transition: all 0.2s;
    text-align: center;
    padding: 5px;
    opacity: 0.45;
    margin-left: 5px;
    background-color: #fff;
    border-radius: 35px;
    filter: grayscale(100%);
    box-shadow: -1px 3px 6px 1px rgba(0, 0, 0, 0.15);

    &.router-link-active {
      opacity: 1;
      transform: scale(1);
      filter: grayscale(0);
      background-color: #303c50;
      &:before {
        background-color: #fff;
        border-radius: 50%;
      }
      span {
        color: #fff;
      }
    }

    span {
      font-size: 0.7em;
      display: inline-block;
      text-align: center;
      color: #000;
      margin-right: 5px;
      @media screen and (max-width: 767px) {
        display: none;
      }
    }
    .count {
      background-color: #cd3f3f;
      width: 29px;
      height: 29px;
      display: inline-block;
      color: #fff;
      border-radius: 50%;
      font-size: 12px;
      line-height: 29px;
      text-align: center;
      transform: scale(0.8);
    }

    &:before {
      content: "";
      width: 30px;
      height: 30px;
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      display: inline-block;
      vertical-align: middle;
      margin-right: 3px;
      transition: all 0.2s;
    }

    &.resume_list {
      &:before {
        background-image: url("~@/assets/img/job_states/resume.png");
      }
    }
    &.interviewing {
      &:before {
        background-image: url("~@/assets/img/job_states/interviewed.png");
      }
    }

    &.interviewed {
      &:before {
        background-image: url("~@/assets/img/job_states/interviewing.png");
      }
    }

    &.not_arrived {
      &:before {
        background-image: url("~@/assets/img/job_states/alternative.png");
      }
    }

    &.interview_result {
      &:before {
        background-image: url("~@/assets/img/job_states/second-view.png");
      }
    }

    &.appoint_result {
      &:before {
        background-image: url("~@/assets/img/job_states/hired.png");
      }
    }
  }
  .go-back {
    font-size: 0.9em;
    background-color: #303c50;
    border-radius: 35px;
    border: none;
    box-shadow: -1px 3px 6px 1px rgba(0, 0, 0, 0.15);
    padding: 6px 10px;
    color: #fff;
    i {
      margin-right: 5px;
    }
    @media screen and (max-width: 767px) {
      display: none;
    }
  }
}
</style>
